import { NgModule } from '@angular/core';
import { SmarshToastComponent } from './smarsh-toast.component';
import { ProgressModule, ToastModule } from '@coreui/angular';
import { NgIf } from '@angular/common';
import { IconModule } from '@coreui/icons-angular';

@NgModule({
  declarations: [SmarshToastComponent],
  imports: [ToastModule, ProgressModule, NgIf, IconModule],
  exports: [SmarshToastComponent],
  providers: []
})
export class SmarshToasterModule {}
